import { useCookie } from '#app'
import { useDayjs } from '#imports'

export const promotionCookie = (promotionType: string) => {
    const dayjs = useDayjs()

    const cookie = useCookie<string[] | null>(promotionType, {
        expires: dayjs.tz().add(1, 'day').toDate(),
        sameSite: 'none',
        secure: true,
    })

    return cookie
}
